export default "__VITE_ASSET__gLARbQeN__"